<template>
	<div>
		<!-- 引入top组件 -->
		<top :windowWidth="windowWidth" :windowHeight="windowHeight"></top>
		
		<topImage :windowWidth="windowWidth" :windowHeight="windowHeight" :image="require('@/assets/img/news/news_back.jpg')"/>
		
		<!-- 新闻列表 -->
		<list :windowWidth="windowWidth" :windowHeight="windowHeight" :newsList="newsList"/>
		
		<!-- 引入底部组件 -->
		<div v-if="windowWidth>=800">
			<bottom></bottom>
		</div>
		
		<right :windowWidth="windowWidth"></right>
	</div>
</template>

<script>
	import top from '@/components/top/top.vue'; //引入top组件
	import list from '@/business/news/components/list.vue'
	import bottom from '@/components/bottom/index.vue'; //引入bottom组件
	import right from '@/components/right/right.vue'; //引入bottom组件
	import topImage from '@/components/topImage/topImage.vue'//引入top图片
	import * as newsApi from "@/api/home/news.js"
	import {
		changeKeywords,
		changeDescription,
		changeTitle
	} from '@/utils/brower.js'
	export default {
		components: {
			top,
			bottom,
			list,
			right,
			topImage
		},
		data() {
			return {
				// 浏览器窗口宽度高度
				windowWidth: 0,
				windowHeight: 0,
				newsList:[],//新闻列表
			}
		},
		
		updated() {
			window.scroll(0,this.$store.state.h_news)
		},
		
		created() {
			this.$i18n.locale = this.$store.state.language;
			this.getNews()
		},
		
		mounted() {
			let that = this;
			that.windowWidth = document.body.clientWidth;
			that.windowHeight = document.body.clientHeight;
			window.onresize = () => {
				return (() => {
					this.windowWidth = document.body.clientWidth;
					this.windowHeight = document.body.clientHeight;
				})();
			};
		},
		
		beforeCreate() {
			changeTitle(this.$t('browerChange.title'))
			changeKeywords(this.$t('browerChange.keywords'))
			changeDescription(this.$t('browerChange.description'))
		},
		
		watch:{
			//双向绑定语言切换
			'$i18n.locale'(val) {
				this.getNews()
				changeTitle(this.$t('browerChange.title'))
				changeKeywords(this.$t('browerChange.keywords'))
				changeDescription(this.$t('browerChange.description'))
			}
		},
		
		computed:{
			
		},
		
		methods:{
			//获取列表
			getNews(){
				newsApi.queryList({language:this.$store.state.language=='cn'?'中文':'English'}).then(res=>{
					if(res.code == 200){
						res.rows.forEach(i=>{
							i.image = this.HttpChange('URL',i.image)
						})
						this.newsList = res.rows
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
</style>